import { LogLevel } from "@azure/msal-browser";
import { reactPlugin } from "./appinsights";
import { SeverityLevel } from "@microsoft/applicationinsights-web";
import { DEV } from "./config";

const ENV = process.env;

// MS Authorization **************************************************************
// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
const msedge = ua.indexOf("Edge/");
const firefox = ua.indexOf("Firefox");
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

// Config object to be passed to Msal on creation
export const authConfig = {
  auth: {
    clientId: ENV.REACT_APP_MSAL_CLIENT_ID, //"24ec565b-8807-42dd-8180-eebf84b60d0a",
    authority: ENV.REACT_APP_MSAL_URL, //possible values see https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-client-application-configuration
    redirectUri: window.location.origin + "/auth-response",
    validateAuthority: false,
    //postLogoutRedirectUri: window.location.origin + "/logged-out"
  },
  cache: {
    //cacheLocation: "sessionStorage", // This configures where your cache will be stored
    cacheLocation: DEV ? "localStorage" : "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            reactPlugin.trackException({
              error: new Error(message),
              severityLevel: SeverityLevel.Error,
            });
            return;
          case LogLevel.Info:
            //console.info(message);
            //reactPlugin.trackTrace({ message: message, severityLevel: SeverityLevel.Information })
            return;
          case LogLevel.Verbose:
            //console.debug(message);
            //reactPlugin.trackTrace({ message: message, severityLevel: SeverityLevel.Verbose })
            return;
          case LogLevel.Warning:
            console.warn(message);
            reactPlugin.trackTrace({
              message: message,
              severityLevel: SeverityLevel.Warning,
            });
            break;
          default:
        }
      },
    },
  },
};
